export default "__VITE_PUBLIC_ASSET__b88a2ddd__"